module.exports = __webpack_public_path__ + "img/Weapon_71.46224904.png";